<template>
  <v-card flat color="transparent">
    <v-card-title v-if="query" style="flex-wrap: nowrap;" class="card-bg-2 title py-2 overflow-hidden">
      <v-icon class="mr-2">label</v-icon>
      <div class="overflow-hidden">
        {{ query.name }}
      </div>
    </v-card-title>
    <v-card-title v-else class="card-bg-2 title py-2">
      <v-icon class="mr-2">label</v-icon>
      New Query
    </v-card-title>
  </v-card>
</template>

<script>
  export default {
    props: {
      query: Object,
    },
  }
</script>

<style scoped>
  .overflow-hidden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>